import { render, staticRenderFns } from "./StickyContentPanel.vue?vue&type=template&id=5d82e61c&scoped=true"
import script from "./StickyContentPanel.vue?vue&type=script&lang=js"
export * from "./StickyContentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82e61c",
  null
  
)

export default component.exports